/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React from 'react';
import EDW_CONST from '../../../common/constants';
import style from '../style/index.scss'
import { ErrorMessage } from '../messaging/ErrorMessage';

export const AssessmentNoData = (props) => {

    const redirectTo = () => {
        let url = EDW_CONST.ALS_DOMAIN + EDW_CONST.ALS_MARK_BOOK;
        window.location.href = url;
    }

    return (
        <div className="no-data">
            <label className="no-data-label">To see insights, please enter assessment results.</label>

            <ul style={{ marginBottom: 20 }}>
                <li>See assessment insights at group level.</li>
                <li>See assessment insights for your students.</li>
            </ul>
            <button className="Btn Button-BG" onClick={redirectTo}>Enter assessment results</button>
        </div>
    )
}


export const BaselineTargetNoData = (props) => {

    const redirectTo = () => {
        let url = EDW_CONST.ALS_DOMAIN + EDW_CONST.ALS_MARK_BOOK;
        window.location.href = url;
    }

    return (
        <div className="no-data">
            <label className="no-data-label">To see more valuable insights, please enter baselines and targets.</label>

            <ul style={{ marginBottom: 20 }}>
                <li>See students who are not making expected progress.</li>
                <li>See students who are not on track to meet their course target.</li>
            </ul>
            <button className="Btn Button-BG" onClick={redirectTo}>Enter baselines and targets</button>
        </div>)
};

export const QuestionNoData = () => {
    const redirectTo = () => {
        let url = EDW_CONST.ALS_DOMAIN + EDW_CONST.ALS_MARK_BOOK;
        window.location.href = url;
    }

    return (<div className="no-data">
        <label className="no-data-label">To see more valuable insights, please enter your data at question-level.</label>
        <p>With question-level data you will be able to view:</p>
        <ul style={{ marginBottom: 20 }}>
            <li>Strongest and weakest questions for your group.</li>
            <li>Group average marks for each question.</li>
            <li>Highest and lowest performing topics.</li>
            <li>Highest and lowest performing skills.</li>
        </ul>
        <button className="Btn Button-BG " onClick={redirectTo} >Enter question marks</button>
    </div>)
}

export const ErrorData = () => {
    return (<div className={style.errorData}>
        <div className={style.errorMsg}> <ErrorMessage message={EDW_CONST.ERROR_MSG} />  </div>
    </div>)
}

export const EmptyData = (props) => {
    return (<div className={style.errorData}>
        <div className={style.errorMsg}>
            <span className={style.emptyMsg}>{props.message}</span>
     </div>
    </div>)
}

